import { render, staticRenderFns } from "./CouponsModule.vue?vue&type=template&id=5eb95a0b&scoped=true"
import script from "./CouponsModule.vue?vue&type=script&lang=js"
export * from "./CouponsModule.vue?vue&type=script&lang=js"
import style0 from "./CouponsModule.vue?vue&type=style&index=0&id=5eb95a0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb95a0b",
  null
  
)

export default component.exports